import { gql } from '@apollo/client';

export const FETCH_REPORT_DEFINITION_TYPES = gql`
    query fetchReportDefinitionTypes {
        lookup {
            reportTypes {
                id
                name
                description
                platform
                helpUrl
            }
        }
    }
`;
